import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { FootfallPredictionAdapter } from '../../../classes/adapters/response/prediction/FootfallPredictionAdapter';
import { Observable } from 'rxjs';
import { DailyFootfallPrediction } from '../../../classes/models/prediction/DailyFootfallPrediction';
import { map } from 'rxjs/operators';
import { FootfallPredictionResponse } from '../../../interfaces/response/PredictionsResponses';

/**
 * This service communicates with backend to retrieve footfall predictions.
 */
@Injectable({
  providedIn: 'root'
})
export class FootfallPredictionService {
  private http = inject(HttpClient);
  private footfallPredictionAdapter = inject(FootfallPredictionAdapter);

  url = environment.apiUrl + '/footfall-predictions';

  /**
   * Retrieves footfall predictions for the given store and date range.
   * @param storeId an identifier of a store.
   * @param from the first date of footfall predictions.
   * @param to the last date of footfall predictions.
   */
  getPredictions(storeId: string, from: string, to: string): Observable<DailyFootfallPrediction[]> {
    const requestParams = {
      params: { store: storeId, fromDate: from, toDate: to }
    };
    return this.http.get(this.url, requestParams).pipe(map(
      (data: FootfallPredictionResponse[]) => data.map(item => this.footfallPredictionAdapter.adapt(item)))
    );
  }
}
